/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LeagueCategoryEnum {
    LEAGUE = 'LEAGUE',
    CUP = 'CUP',
    YOUTH = 'YOUTH',
    WOMEN = 'WOMEN',
    VSS_YOUTH = 'VSS_YOUTH',
    VSS_FREE_TIME = 'VSS_FREE_TIME',
    VIENNA = 'VIENNA',
    KIDS_CUP = 'KIDS_CUP',
    MINI_EM = 'MINI_EM',
    CALCIO_A_5 = 'CALCIO_A_5',
    OTHER = 'OTHER',
}
